/* eslint-disable @typescript-eslint/no-explicit-any */
import { oneDecimalPercentFormatValidateFloatTrueWithNegativeValues } from 'common/formats/formats';
import { CURRENCY_COLUMNS } from 'dashboard409a/common/constants/components/performanceMetricsTable';
import { alphabetGenerator } from 'utilities/alphabet-utilities';
import {
  TABLE_EIGHTH_TITLE,
  TABLE_ELEVENTH_TITLE,
  TABLE_FIFTH_TITLE,
  TABLE_FOURTH_TITLE,
  TABLE_NINTH_TITLE,
  TABLE_SECOND_TITLE,
  TABLE_SEVENTH_TITLE,
  TABLE_SIXTH_TITLE,
  TABLE_TENTH_TITLE,
  TABLE_THIRD_TITLE,
  TABLE_TITLE,
  TABLE_TWELFTH_TITLE,
} from './rowConfig';

export default async ({ columns, rowConfig }: any) => {
  let cells = {};
  const alphabet = alphabetGenerator([], columns.length);

  rowConfig.forEach((row: any, rowIdx: any) => {
    columns.forEach((col: any, colIdx: any) => {
      const rowNumber = rowIdx + 1;
      const columnLegend = alphabet[colIdx];
      const key = columnLegend + rowNumber;

      let value = col[row.alias];

      if (rowNumber === 1 || row.alias === TABLE_TITLE) {
        switch (colIdx) {
          case 0:
            value = TABLE_SECOND_TITLE;
            break;
          case 1:
            value = TABLE_THIRD_TITLE;
            break;
          case 2:
            value = TABLE_FOURTH_TITLE;
            break;
          case 3:
            value = TABLE_FIFTH_TITLE;
            break;
          case 4:
            value = TABLE_SIXTH_TITLE;
            break;
          case 5:
            value = TABLE_SEVENTH_TITLE;
            break;
          case 6:
            value = TABLE_EIGHTH_TITLE;
            break;
          case 7:
            value = TABLE_NINTH_TITLE;
            break;
          case 8:
            value = TABLE_TENTH_TITLE;
            break;
          case 9:
            value = TABLE_ELEVENTH_TITLE;
            break;
          case 10:
            value = TABLE_TWELFTH_TITLE;
            break;
          default:
            value = '';
            break;
        }
      }

      let { format } = row;

      if (!CURRENCY_COLUMNS.includes(colIdx)) {
        format = oneDecimalPercentFormatValidateFloatTrueWithNegativeValues;
      }

      let { expr } = row;

      if (expr?.match(/@@/g)) {
        expr = expr.replace(/@@/g, `${columnLegend}`);
      }

      cells = {
        ...cells,
        [key]: {
          ...row,
          key,
          expr,
          rowSpan: 1,
          columnLegend,
          value,
          format,
        },
      };
    });
  });

  return cells;
};
